module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-09.066f1673.jpg";